webpackJsonp([226020273838829],{

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(70);
	
	var _helloColor = __webpack_require__(63);
	
	var _helloColor2 = _interopRequireDefault(_helloColor);
	
	var _colors2 = __webpack_require__(11);
	
	var _colors3 = _interopRequireDefault(_colors2);
	
	var _colors4 = __webpack_require__(56);
	
	var _colors = _interopRequireWildcard(_colors4);
	
	var _mapProps = __webpack_require__(7);
	
	var _mapProps2 = _interopRequireDefault(_mapProps);
	
	var _styleguide = __webpack_require__(14);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _styleguide.ContentRow,
	    null,
	    _react2.default.createElement(
	      _styleguide.Title,
	      { h: '2', scale: '3', mx: 'auto', my: '0', width: 'max' },
	      'Plans and Pricing'
	    ),
	    _react2.default.createElement(
	      _styleguide.Paragraph,
	      { mx: 'auto', mb: '3', width: 'max' },
	      'Duis occaecat occaecat quis et ad aute ullamco sit sint.'
	    ),
	    _react2.default.createElement(
	      _styleguide.Flex,
	      { align: 'center', justify: 'center' },
	      TIERS.map(function (tier, i) {
	        return [i > 0 && _react2.default.createElement(_styleguide.Fill, { key: i, flex: 'tenth', scale: '2' }), _react2.default.createElement(Tier, _extends({ key: tier.title }, tier))];
	      })
	    )
	  );
	};
	
	var TIERS = [{
	  id: 'student',
	  title: 'Student',
	  price: 9,
	  color: _colors3.default.cyan[4]
	}, {
	  id: 'pro',
	  title: 'Pro',
	  price: 99,
	  color: _colors3.default.violet[6]
	}];
	
	var TierContainer = /*#__PURE__*/(0, _styledComponents2.default)(_styleguide.Fill).attrs({ column: true, align: 'center', flex: 'fifth', p: 2 }).withConfig({
	  displayName: 'pricing__TierContainer'
	})(['min-height:20rem;background-color:', ';color:', ';border-radius:0.5rem;', ';'], _colors3.default.gray[6], _colors3.default.white, (0, _mapProps2.default)({
	  background: function background(_background) {
	    return (0, _styledComponents.css)(['background-color:', ';'], _background);
	  }
	}));
	var Price = /*#__PURE__*/(0, _styledComponents2.default)(_styleguide.Title).withConfig({
	  displayName: 'pricing__Price'
	})(['font-size:4rem;']);
	
	var TierNote = /*#__PURE__*/(0, _styledComponents2.default)(_styleguide.Paragraph).withConfig({
	  displayName: 'pricing__TierNote'
	})(['max-width:12rem;']);
	
	var Tier = function Tier(_ref) {
	  var id = _ref.id,
	      title = _ref.title,
	      price = _ref.price,
	      color = _ref.color,
	      CTA = _ref.CTA;
	
	  return _react2.default.createElement(
	    TierContainer,
	    { background: color },
	    _react2.default.createElement(
	      _styleguide.Title,
	      { h: '3', pt: '2', scale: '2' },
	      title
	    ),
	    _react2.default.createElement(_styleguide.Fill, { flex: 'fourth', scale: '2' }),
	    _react2.default.createElement(
	      _styleguide.Flex,
	      null,
	      _react2.default.createElement(
	        _styleguide.Title,
	        { weight: 'light', color: _colors3.default.gray[2] },
	        '$'
	      ),
	      _react2.default.createElement(
	        Price,
	        { px: '1' },
	        price
	      )
	    ),
	    _react2.default.createElement(_styleguide.Fill, { flex: 'fourth', scale: '2' }),
	    _react2.default.createElement(
	      _styleguide.Paragraph,
	      { lines: '2' },
	      'per user per month billed monthly'
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/pay' + ('?plan=' + id) },
	      _react2.default.createElement(
	        Button,
	        { color: color },
	        CTA || 'Get started'
	      )
	    )
	  );
	};
	
	var Form = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'pricing__Form'
	})(['display:flex;align-items:center;', ' ', ' padding-bottom:1.5rem;margin-bottom:1.5rem;box-shadow:0 .1875rem 0 #e6ebf1;'], '' /* margin-bottom: 2.5rem;
	                                                                                                                                 padding-bottom: 2.5rem;
	                                                                                                                                 border-bottom: .1875rem solid #e6ebf1; */, '' /* padding-top: 1rem; */);
	var Label = /*#__PURE__*/_styledComponents2.default.label.withConfig({
	  displayName: 'pricing__Label'
	})(['color:#6b7c93;font-weight:300;letter-spacing:0.025em;']);
	var Email = /*#__PURE__*/_styledComponents2.default.input.attrs({ type: 'text', placeholder: 'tom@jerry.com' }).withConfig({
	  displayName: 'pricing__Email'
	})(['color:\'#424770\';font-size:1.5rem;line-height:2rem;letter-spacing:\'0.025em\';::placeholder{color:#aab7c4;}display:block;margin:.625rem 0 1.25rem 0;max-width:30rem;padding:.625rem .875rem;box-shadow:rgba(50,50,93,0.14902) 0 .0625rem .1875rem,rgba(0,0,0,0.0196078) 0 .0625rem 0;border-radius:.25rem;background:white;transition:all 150ms ease;&:hover{', ';box-shadow:rgba(50,50,93,0.109804) 0 .25rem .375rem,rgba(0,0,0,0.0784314) 0 .0625rem .1875rem;transition:all 150ms ease;}&:focus{', ';box-shadow:0 .4375rem .875rem rgba(50,50,93,0.1),0 .1875rem .375rem rgba(0,0,0,0.08);transition:all 150ms ease;}'], '' /* box-shadow:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     rgba(50, 50, 93, 0.109804) 0 .125rem .0625rem,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     rgba(0, 0, 0, 0.0784314) 0 0 .0625rem
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     ; */, '' /* box-shadow:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              rgba(50, 50, 93, 0.109804) 0 .25rem .375rem,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              rgba(0, 0, 0, 0.0784314) 0 .0625rem .1875rem
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              ; */);
	
	var Button = /*#__PURE__*/_styledComponents2.default.button.withConfig({
	  displayName: 'pricing__Button'
	})(['white-space:nowrap;border:0;outline:0;display:inline-block;height:2.5rem;line-height:2.5rem;padding:0 .875rem;box-shadow:0 .25rem .375rem rgba(50,50,93,0.11),0 .0625rem .1875rem rgba(0,0,0,0.08);color:#fff;border-radius:.25rem;font-size:.9375rem;font-weight:600;letter-spacing:0.025em;background-color:', ';text-decoration:none;transition:all 150ms ease;margin-top:0.75rem;&:hover{color:#fff;cursor:pointer;background-color:#7795f8;transform:translateY(-.0625rem);box-shadow:0 .4375rem .875rem rgba(50,50,93,0.1),0 .1875rem .375rem rgba(0,0,0,0.08);}&:active{color:#fff;cursor:pointer;background-color:', ';transform:translateY(.0625rem);box-shadow:0 .1875rem .3125rem rgba(50,50,93,0.1),0 0 .0625rem rgba(0,0,0,0.08);}', ';'], _colors3.default.indigo[6], _colors3.default.indigo[8], (0, _mapProps2.default)({
	  color: function (_color) {
	    function color(_x) {
	      return _color.apply(this, arguments);
	    }
	
	    color.toString = function () {
	      return _color.toString();
	    };
	
	    return color;
	  }(function (color) {
	    var lighter = (0, _polished.lighten)(0.05, color);
	    var darker = (0, _polished.darken)(0, color);
	    return (0, _styledComponents.css)(['color:', ';background-color:', ';&:hover{background-color:', ';}&:active{background-color:', ';}'], color, _colors3.default.white, lighter, darker);
	  })
	}));
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pricing-js-f07b4791674976f30631.js